export interface Testimonial {
  name: string
  role: string
  location: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Darren M.',
    role: 'Master Technician, 19 years in the trade',
    location: 'Birmingham, United Kingdom',
    quote:
      'We started taking EV work two years ago and I was constantly opening five tabs to figure out where to begin. Now I open the fault-finding module, match the symptom and I already know which system to look at first. The battery decision tree alone saved me half a day on a no-READY job last week.',
  },
  {
    name: 'Chris Whitaker',
    role: 'Independent workshop owner, 44',
    location: 'Calgary, Canada',
    quote:
      'What sold me is that it is not theory. It is diagrams, symptom paths and scan-data context I can actually use with a customer waiting. My two younger techs use the component identification guide every day and they are asking me far fewer questions.',
  },
  {
    name: 'Tony Alvarez',
    role: 'Dealership diagnostic technician, 36',
    location: 'Phoenix, United States',
    quote:
      'The reduced-power-after-fast-charging case study is exactly the job I had a month earlier, and I chased the inverter for hours. Reading the thermal protection logic laid out like that changed how I approach propulsion complaints completely.',
  },
  {
    name: 'Ryan Patterson',
    role: 'Mobile auto electrician, 31',
    location: 'Brisbane, Australia',
    quote:
      'I work out of a van so I do not have a workshop library. Having the scan data interpretation guide and the DTC decision guide on my tablet means I can structure a diagnosis on the driveway instead of guessing or sending the car away.',
  },
  {
    name: 'Stephen Doyle',
    role: 'Workshop foreman, 52',
    location: 'Manchester, United Kingdom',
    quote:
      'After 30 years on combustion engines, hybrids felt like someone moved the goalposts. This laid out the architecture, energy flow and interlocks in a way that finally clicked. The worksheets also made our handovers and documentation far more consistent.',
  },
]
